import { Flex, Link, Stack, Text } from '@chakra-ui/react';

import { ArrowRight } from '@/client/components/icons/ContinuIcons';
import { Link as RouterLink } from 'react-router-dom';

interface LearnerDashboardOverviewContentContainerProps {
  title: string;
  link: {
    label: string;
    route: string;
  };
  children: React.ReactNode;
}

export default function LearnerDashboardOverviewContentContainer({
  title,
  link,
  children,
}: LearnerDashboardOverviewContentContainerProps) {
  return (
    <Stack spacing={6} paddingTop={4}>
      <Flex
        justifyContent="space-between"
        alignItems="center"
        borderBottom="1px solid"
        borderBottomColor="neutral.200"
        paddingBottom={4}
      >
        <Text fontSize="20px" fontWeight={600} color="baseBlack">
          {title}
        </Text>

        <Link as={RouterLink} to={link.route}>
          <Flex
            alignItems="center"
            gap={2}
            color="baseBlack"
            _hover={{ color: 'neutral.700' }}
            transition="color 400ms"
          >
            <Text fontSize="14px" fontWeight={600}>
              {link.label}
            </Text>

            <ArrowRight />
          </Flex>
        </Link>
      </Flex>

      {children}
    </Stack>
  );
}
